import React from "react";
import axios from "axios";
import { useContext, createContext, useState } from "react";
import { SortByGenreContext} from "./sortByGenre";
import {useHistory} from "react-router-dom";

export const MovieDataContext = createContext();

const MovieDataContextProvider = (props) => {

  let history = useHistory();
  const apiKey = process.env.REACT_APP_API_KEY
  const {setMovieInfo} = useContext(SortByGenreContext)
  const [info, setInfo] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [key, setKey] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const fetchData = async (name) => {
    let url = null;
    setLoading(true);
    setInfo([]);
    setSearchResult([]);
    setMovieInfo([]);
    if (name === "toprated") {
      url =
        `https://api.themoviedb.org/3/movie/top_rated?api_key=${apiKey}`;
    } else if (name === "popular") {
      url =
        `https://api.themoviedb.org/3/movie/popular?api_key=${apiKey}`;
    } else if (name === "upcoming") {
      url =
        `https://api.themoviedb.org/3/movie/upcoming?api_key=${apiKey}`;
    } else if (name === "nowplaying") {
      url =
        `https://api.themoviedb.org/3/movie/now_playing?api_key=${apiKey}`;
    }else{
      history.push("/error");
    }
    try {
      const res = await axios.get(url);
      setInfo(res.data.results);
      setKey(name);

      setLoading(false);
    } catch (err) {
      history.push("/error");
      console.log(err);
    }
  };
  const searchMovie = async (searchItem) => {
    setInfo([]);
    setMovieInfo([]);
    setLoading(true);
    try {
      const Murl =
      `https://api.themoviedb.org/3/search/movie?api_key=${apiKey}`;
    const resultData = await axios.get(Murl, { params: { query: searchItem } });
    console.log("search item called");
    console.log(resultData.data.results);
    setSearchResult(resultData.data.results);
    setLoading(false);

    } catch (error) {
      setLoading(false);
      history.push("/error");

    }
  };
  return (
    <div>
      <MovieDataContext.Provider
        value={{ info, fetchData, Loading, key, searchMovie, searchResult, setSearchResult, setInfo }}
      >
        {props.children}
      </MovieDataContext.Provider>
    </div>
  );
};

export default MovieDataContextProvider;
